module.exports = __webpack_public_path__ + "img/twitter.087c7c00.png";